/**
 * Login Replacer View
 */

define(function(require, exports, module) {
    'use strict';

    var LoginView = require('portlets/login/login.view');
    var i18n = require('i18n');

    module.exports = LoginView.extend({
        getTmplData: function() {
            return {
                validationConfig: {
                    userName: {
                        length: {
                            min: 5,
                            max: 32,
                            message: i18n.t('playtech.mobile.system.user.tooltip.loginUserName.length', 5, 32)
                        },
                        regexp: {
                            regexp: /^[A-Za-z0-9-.@_]+$/,
                            message: i18n.t('playtech.mobile.system.user.tooltip.loginUserName.regexp')
                        },
                        required: true
                    },
                    password: {
                        length: {
                            min: 8,
                            max: 20,
                            message: i18n.t('playtech.mobile.system.user.tooltip.loginPassword.length', 8, 20)
                        },
                        regexp: {
                            regexp: /^[A-Za-z0-9-.@_$%&!?+#\\\/,*]+$/,
                            message: i18n.t('playtech.mobile.system.user.tooltip.loginPassword.regexp')
                        },
                        required: true
                    },
                    fitToPlay: {
                        required: Playtech.API.auth.getFitToPlaySubmissionRequired()
                    }
                }
            };
        }
    });
});
